import { useTranslation } from 'react-i18next';
import { GeneralModal } from '@framework/ui/elements/GeneralModal';
import { Button } from '@framework/ui/atoms/Button';

type Props = {
  onClose(): void;
};

export const DisconnectedNotificationModal: React.FC<Props> = ({ onClose }: Props) => {
  const { t } = useTranslation();
  return (
    <GeneralModal
      isOpen={true}
      onClose={onClose}
      title={t('viewModel.connectionStatus.disconnected')}
      submitButton={
        <Button color="secondary" onClick={onClose}>
          {t('common.action.close')}
        </Button>
      }
      cancelButton={<></>}
      shouldCloseOnOverlayClick={false}
    >
      <div className="p-4" style={{ width: '600px' }}>
        {t('viewModel.disconnectedModal.description')}
      </div>
    </GeneralModal>
  );
};
